import React, { createContext, useState } from "react";

export const ContactUsContext = createContext({});

export const CONTACT_MODAL_TYPES = {
  CONTACT: "contact",
  BUSINESS_PRICING: "business-pricing",
};

const ContactUsProvider = ({ children }) => {
  const [theme] = useState(false);
  const [message, setMessage] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState(CONTACT_MODAL_TYPES.CONTACT);
  const openContactModal = (type = CONTACT_MODAL_TYPES.CONTACT) => {
    setModalType(type);
    setIsOpen(true);
  };
  const closeContactModal = () => {
    setIsOpen(false);
  };

  return (
    <ContactUsContext.Provider
      value={{
        theme,
        message,
        setMessage,
        isOpen,
        setIsOpen,
        modalType,
        openContactModal,
        closeContactModal,
      }}
    >
      {children}
    </ContactUsContext.Provider>
  );
};

export default ContactUsProvider;
